import React, { useEffect, useState } from 'react'

const V3AuthGuard = ({ children }) => {
  const [isBlocked, setIsBlocked] = useState(false)
  const [isRedirecting, setIsRedirecting] = useState(false)

  useEffect(() => {
    // Verifică dacă suntem în mod demo - dacă da, permitem accesul fără verificări
    const demoMode = localStorage.getItem('demo_mode')
    if (demoMode === 'omnia') {
      // În mod demo, permitem accesul direct fără verificări
      return
    }

    // Verifică dacă utilizatorul a fost redirecționat din cauza timeout-ului
    const guestTimeout = localStorage.getItem('v3_guest_timeout')
    if (guestTimeout === 'true') {
      // Dacă da, redirecționează imediat la register
      if (!isRedirecting) {
        setIsRedirecting(true)
        // Folosim setTimeout pentru a evita problemele de re-renderizare
        setTimeout(() => {
          window.location.replace('/v3.0/register')
        }, 0)
      }
      return
    }

    // Verifică dacă utilizatorul este autentificat
    const token = localStorage.getItem('authToken')
    const userData = localStorage.getItem('userData')
    
    if (!token || !userData) {
      // Dacă nu este autentificat, începe timer-ul de 2 minute
      const timer = setTimeout(() => {
        setIsBlocked(true)
        // Setăm flag-ul pentru a bloca utilizatorul pe register
        localStorage.setItem('v3_guest_timeout', 'true')
        // Folosim setTimeout pentru a evita problemele de re-renderizare
        setTimeout(() => {
          window.location.replace('/v3.0/register')
        }, 0)
      }, 120000) // 2 minute

      return () => clearTimeout(timer)
    }

    // Verifică dacă datele utilizatorului sunt valide
    try {
      const user = JSON.parse(userData)
      if (!user || !user.email) {
        // Dacă datele sunt invalide, începe timer-ul
        const timer = setTimeout(() => {
          setIsBlocked(true)
          // Setăm flag-ul pentru a bloca utilizatorul pe register
          localStorage.setItem('v3_guest_timeout', 'true')
          // Folosim window.location.replace pentru redirect sigur
          window.location.replace('/v3.0/register')
        }, 120000) // 2 minute

        return () => clearTimeout(timer)
      }
    } catch (error) {
      // Dacă datele sunt corupte, începe timer-ul
      const timer = setTimeout(() => {
        setIsBlocked(true)
        // Setăm flag-ul pentru a bloca utilizatorul pe register
        localStorage.setItem('v3_guest_timeout', 'true')
        // Folosim setTimeout pentru a evita problemele de re-renderizare
        setTimeout(() => {
          window.location.replace('/v3.0/register')
        }, 0)
      }, 120000) // 2 minute

      return () => clearTimeout(timer)
    }
  }, [])

  // Dacă este în proces de redirect, nu randa nimic
  if (isRedirecting) {
    return null
  }

  // Dacă este blocat după timeout, nu randa nimic (redirect-ul se face automat)
  if (isBlocked) {
    return null
  }

  // Dacă totul este OK sau utilizatorul nu este autentificat (invitat), randează conținutul
  return children
}

export default V3AuthGuard
